import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import CloneDiscountCampaignContainer from 'app/containers/Marketing/DiscountCampaignManagement/CloneCampaign'

const CloneDiscountCampaignPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.clone_campaign)}</PageTitle>
      <CloneDiscountCampaignContainer />
    </>
  )
}
const CloneDiscountCampaignPage = memo(CloneDiscountCampaignPageCpn, isEqual)

export default CloneDiscountCampaignPage
